import React from "react";
import * as Option from "@utils/Option";
import type { DocumentRefineViewProps } from "@ps-bridge/contracts/documentRefine";
import RefinePanel, { type RefinePhase } from "@view/panels/document/Refine.panel";

const RefineComponent: React.FC<DocumentRefineViewProps> = ({
  onSubmit,
  mostRecentSection,
}) => {
  const phase: RefinePhase = Option.fold(
    mostRecentSection,
    () => "loading",
    () => "content",
  );

  return (
    <RefinePanel
      phase={phase}
      mostRecentSection={mostRecentSection}
      onSubmit={onSubmit}
    />
  );
};

export default RefineComponent;
